import React, { useEffect, useState } from "react";

import NotificationList from "./NotificationList";
import { getAllNotifications, setNewNotification, showNotificationsBadge } from "api";
import notificationIcon from "assets/icons/notificationIcon.svg";
import styled from "styled-components";
import useInfiniteScroll from "hooks/useInfinteScroll";
import { connect } from "react-redux";
import { channelEventHandlers, usePrivateChannels } from "ws/Channels";

const Wrapper = styled.div`
  position: relative;

  .bell {
    position: relative;
    // padding: 1.2rem;
    border-radius: 4px;
    transition: all 0.2s ease-out;
    gap: 0.6rem;

    .icon {
      height: 20px;
    }

    .text {
      color: var(--grey_6);
    }

    &:hover {
      background-color: var(--background);
    }
  }

  .badge {
    position: absolute;
    top: -3px;
    right: -3px;
    height: 10px;
    width: 10px;
    border-radius: 50%;
    background-color: #ff0000;
  }

  @media screen and (max-width: 768px) {
    .bell .text {
      display: none;
    }
  }
`;

function useNotificationChannel (
  authUserId,
  onChange
) {
  const channels = usePrivateChannels(authUserId)
  useEffect(() => {
    if (channels) {
      channels.listenToAll(onChange)
    }
    // eslint-disable-next-line
  }, [channels])
}

const Notifications = ({notifications_badge, user, brands}) => {
  const [showNotifications, setShowNotifications] = useState(false);
  const { loading, list, reFetch, lastListElementRef } = useInfiniteScroll(getAllNotifications, "notifications");

  const handleBellClick = () => {
    setShowNotifications(true);
    if (!notifications_badge) return;
    showNotificationsBadge(false);
  };

  const handleNotificationsEvent = (eventName, data) => {
    reFetch();
    setNewNotification(data);
    console.log(data);
    
    if (!["new_conversation_message", "new_social_comment"].includes(data.event)) {
      showNotificationsBadge(true);
    }
    
    channelEventHandlers[data.event]?.(true, data);
  }

  useNotificationChannel(user?.id, handleNotificationsEvent);

  return (
    <Wrapper>
      <button className="flexRow alignCenter bell notification-tour" title="Notifications" onClick={handleBellClick}>
        {notifications_badge && <span className="badge"></span>}
        <img
          className="icon"
          src={notificationIcon}
          alt="notificationIcon"
        />
      </button>
      {showNotifications && (
        <NotificationList
          notifications={list}
          setShowNotifications={setShowNotifications}
          loading={loading}
          lastListElementRef={lastListElementRef}
          brands={brands}
        />
      )}
    </Wrapper>
  );
};

const mapStateToProps = state => {
  return {
    notifications_badge: state.notifications_badge,
    user: state.user,
    brands: state.brands,
  }
}

export default connect(mapStateToProps)(Notifications);
